import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AgeEstimationConsent.css';
import {
  ArrowForwardRounded,
  InfoOutlined,
  LockOutlined,
  ShieldOutlined,
  TimerOutlined
} from '@mui/icons-material';
import { useIdentification } from './IdentificationContext';
import {
  BackButton,
  EnterpriseButton,
  EnterpriseCard,
  EnterpriseGrid,
  EnterpriseHero,
  EnterpriseShell,
  EnterpriseTopBar
} from './ui/EnterpriseLayout';

function AgeEstimationConsent() {
  const navigate = useNavigate();
  const [consent1, setConsent1] = useState(false);
  const [consent2, setConsent2] = useState(false);
  const { createIdentification } = useIdentification();
  const [isCreating, setIsCreating] = useState(false);

  const canContinue = consent1 && consent2;

  return (
    <EnterpriseShell>
      <EnterpriseTopBar
        right={
          <>
            <BackButton onClick={() => navigate(-1)} />
            <span className="vt-chip vt-chip--subtle">Age estimation</span>
          </>
        }
      />

      <EnterpriseHero
        title="Consent required"
        subtitle="Before we start, please review and accept the consent items below."
      />

      <EnterpriseGrid columns={1}>
        <EnterpriseCard>
          <div className="vt-cardHeader">
            <div className="vt-iconTile" aria-hidden="true">
              <ShieldOutlined className="vt-iconTileIcon" />
            </div>
            <div>
              <h2 className="vt-cardTitle">What you're agreeing to</h2>
            </div>
          </div>

          <ul className="vt-list">
            <li className="vt-listItem">
              <InfoOutlined className="vt-listIcon" />
              <span>Your face image may be treated as biometric data under some laws.</span>
            </li>
            <li className="vt-listItem">
              <TimerOutlined className="vt-listIcon" />
              <span>Your image is used only to estimate age and not for any other purpose.</span>
            </li>
            <li className="vt-listItem">
              <LockOutlined className="vt-listIcon" />
              <span>Your image is deleted immediately after the estimation is completed.</span>
            </li>
          </ul>

          <div style={{ height: 14 }} />

          <div className="vt-card" style={{ padding: 14, boxShadow: 'var(--vt-shadow-soft)' }}>
            <label style={{ display: 'flex', gap: 12, alignItems: 'flex-start', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={consent1}
                onChange={(e) => setConsent1(e.target.checked)}
                style={{ width: 18, height: 18, marginTop: 2 }}
              />
              <span style={{ color: 'var(--vt-muted)', lineHeight: 1.5 }}>
                I consent to Veritage&apos;s collection and use of an image of my face to estimate my age.
              </span>
            </label>

            <div style={{ height: 10 }} />

            <label style={{ display: 'flex', gap: 12, alignItems: 'flex-start', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={consent2}
                onChange={(e) => setConsent2(e.target.checked)}
                style={{ width: 18, height: 18, marginTop: 2 }}
              />
              <span style={{ color: 'var(--vt-muted)', lineHeight: 1.5 }}>
                I have read and acknowledge Veritage&apos;s Privacy Notice including Biometrics Policy.
              </span>
            </label>
          </div>

          <div className="vt-actions">
            <EnterpriseButton
              variant="primary"
              onClick={async () => {
                try {
                  setIsCreating(true);
                  await createIdentification();
                  navigate('/age-estimation/scan');
                } catch (error) {
                  console.error('Failed to create identification:', error);
                  alert('Failed to start age estimation. Please try again.');
                } finally {
                  setIsCreating(false);
                }
              }}
              disabled={!canContinue || isCreating}
            >
              <span>{isCreating ? 'Starting…' : 'Continue'}</span>
              <ArrowForwardRounded className="vt-btnIcon" />
            </EnterpriseButton>
            <EnterpriseButton variant="secondary" type="button" onClick={() => navigate('/')}>
              Back to options
            </EnterpriseButton>
          </div>
        </EnterpriseCard>
      </EnterpriseGrid>
    </EnterpriseShell>
  );
}

export default AgeEstimationConsent;
